import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Transition as _Transition, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/user-head-default-white.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ant-layout-header-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-img",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_2 = { class: "ant-layout-header-right" }
const _hoisted_3 = { class: "layout-shortcut-menu" }
const _hoisted_4 = { class: "layout-userinfo-username" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "layout-shortcut-menu" }
const _hoisted_8 = { class: "layout-userinfo-username" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold"} }, "联系我们", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "如您有任何疑问，可随时通过以下邮箱联系我们", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "kf@neutonhealth.com", -1)

import { reactive, createVNode } from 'vue';
import LayoutSider from '@/components/common/LayoutSider.vue';
import { state as globalState, service as globalService } from '@/modules/global';
import { state as pageTabState, service as breadCrumbsService } from '@/modules/page-tab';
import PageTabs from '@/components/common/PageTabs.vue';
import { ExclamationCircleOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { useRole } from '@/modules/medical/hooks/useRole';
import HeaderSearch from '@/components/common/HeaderSearch.vue';
import HospitalList from '@/components/base/login/login-content/login-form/HospitalList.vue';
import router from '@/config/router';
import ForgetPassword from '@/components/base/login/login-content/login-form/ForgetPassword.vue';
import { HospitalItem } from '@/@types/hospital';


export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const { judgeRoleIsDoc } = useRole();

const state = reactive({
  /** 显示修改密码弹出框 */
  visibleChangePassword: false,
  /** 联系我们弹出框 */
  relaUsVisible: false,
  /** 医院切换列表可见性 */
  hospitalListVisible: false,
});

const logout = () => {
  Modal.confirm({
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: '确定注销登录并退出系统吗？',
    onOk() {
      return globalService.logout();
    },
    onCancel() {},
  });
};

/** 根据权限判断是否有个人中心 */
const showRightTopByRole = () => {
  return globalState.permissions.find(item => item === 'system:user:usercenter');
};

/** 切换医院 */
const changeHospital = () => {
  state.hospitalListVisible = true;
};

/** 打开联系我们 */
const openRelative = () => {
  state.relaUsVisible = true;
};

const goToUserCenter = () => {
  router.push('/profile');
};

/** 动态切换医院 */
const chooseHospital = (val: HospitalItem) => {
  if (val.hospitalId) {
    state.hospitalListVisible = false;
    breadCrumbsService.curmbToHome();
    router.push('/home');
  } else {
    message.warning('请选择医院');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["layout-sider-shadow", { show: _unref(globalState).showMainMenu }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(globalState).showMainMenu = false))
        }, null, 2),
        _createVNode(_component_a_layout_sider, {
          collapsed: _unref(globalState).collapsed,
          "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_unref(globalState).collapsed) = $event)),
          collapsible: "",
          "collapsed-width": 60,
          width: "310",
          class: _normalizeClass({ 'ant-layout-sider-hidden': _unref(globalState).showMainMenu })
        }, {
          default: _withCtx(() => [
            _createVNode(LayoutSider)
          ]),
          _: 1
        }, 8, ["collapsed", "class"]),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            (_unref(globalState).isMobile)
              ? (_openBlock(), _createBlock(_component_a_layout_header, {
                  key: 0,
                  class: "header",
                  style: {"background":"#2c314c","padding":"0"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_dropdown, { placement: "bottomRight" }, {
                          overlay: _withCtx(() => [
                            _createVNode(_component_a_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, {
                                  key: "user-center",
                                  onClick: goToUserCenter
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 个人中心 ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  key: "change-password",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (state.visibleChangePassword = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 修改密码 ")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  key: "logout",
                                  onClick: logout
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 退出登录 ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "layout-userinfo",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                            }, [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(globalState).userInfo.name), 1),
                              _hoisted_5
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", {
                        class: "layout-shortcut-main-menu",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(globalState).showMainMenu = !_unref(globalState).showMainMenu))
                      }, [
                        (!_unref(globalState).showMainMenu)
                          ? (_openBlock(), _createBlock(_unref(MenuOutlined), {
                              key: 0,
                              style: { color: '#9EA2C0', fontSize: '24px' }
                            }))
                          : (_openBlock(), _createBlock(_unref(CloseOutlined), {
                              key: 1,
                              style: { color: '#9EA2C0', fontSize: '24px' }
                            }))
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_layout_header, {
                  key: 1,
                  class: "header",
                  style: {"background":"#fff","padding":"0","height":"62px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(PageTabs, {
                      tabList: _unref(pageTabState).pageTabs,
                      "onUpdate:tabList": _cache[5] || (_cache[5] = ($event: any) => ((_unref(pageTabState).pageTabs) = $event)),
                      activeKey: _unref(pageTabState).activePage,
                      "onUpdate:activeKey": _cache[6] || (_cache[6] = ($event: any) => ((_unref(pageTabState).activePage) = $event))
                    }, null, 8, ["tabList", "activeKey"]),
                    (_unref(judgeRoleIsDoc)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(globalState).userInfo.extendInfo?.hospitalName), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_dropdown, { placement: "bottomRight" }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, null, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", null, [
                                _createVNode(_component_a_menu_item, {
                                  key: "user-center",
                                  onClick: goToUserCenter
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 个人中心 ")
                                  ]),
                                  _: 1
                                })
                              ], 512), [
                                [_vShow, showRightTopByRole()]
                              ]),
                              _createVNode(_component_a_menu_item, {
                                key: "change-password",
                                onClick: openRelative
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 联系我们 ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_menu_item, {
                                key: "change-password",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (state.visibleChangePassword = true))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 修改密码 ")
                                ]),
                                _: 1
                              }),
                              (_unref(judgeRoleIsDoc)())
                                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: "change-hospital",
                                    onClick: changeHospital
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 切换医院 ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_a_menu_item, {
                                key: "logout",
                                onClick: logout
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 退出登录 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "layout-userinfo",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                          }, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(judgeRoleIsDoc)() ? _unref(globalState).userInfo.doctorName : _unref(globalState).userInfo.nickName), 1),
                            _createElementVNode("img", {
                              src: _unref(globalState).userInfo?.avatar || require('@/assets/img/user-head-default.png')
                            }, null, 8, _hoisted_9)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })),
            _createVNode(_component_a_layout_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view, null, {
                  default: _withCtx(({ Component, route }) => [
                    _createVNode(_Transition, { name: "page-change" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_KeepAlive, { max: 30 }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                            key: route.fullPath
                          }))
                        ], 1024))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(ForgetPassword, {
                  visible: state.visibleChangePassword,
                  "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((state.visibleChangePassword) = $event)),
                  title: "修改密码"
                }, null, 8, ["visible"]),
                _createVNode(_component_a_modal, {
                  visible: state.relaUsVisible,
                  "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((state.relaUsVisible) = $event)),
                  closable: false,
                  footer: false
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode(HospitalList, {
                  visible: state.hospitalListVisible,
                  "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((state.hospitalListVisible) = $event)),
                  onConfirm: chooseHospital
                }, null, 8, ["visible"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ForgetPassword, {
      visible: _unref(globalState).isFirst,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_unref(globalState).isFirst) = $event)),
      title: "修改密码",
      "is-first": _unref(globalState).isFirst
    }, null, 8, ["visible", "is-first"])
  ], 64))
}
}

})